import { Link } from 'react-router-dom'

import NavBar from '../landing/navbar'
import Footer from '../landing/footer'
import { getAllPosts } from './posts'
import './blog.scss'

const BlogList = () => {
  const posts = getAllPosts()

  return (
    <div className='blog-page'>
      <header role='banner'>
        <NavBar />
      </header>
      <main className='container col-xxl-8 py-5 blog-list-page' role='main'>
        <p className='blog-back mb-3'>
          <Link to='/'>← Back to home</Link>
        </p>
        <h1 className='blog-list-title'>Blog</h1>
        <p className='blog-list-subtitle'>Learn more about invoicing with TinyInvoice.app</p>
        <ul className='list-unstyled row g-4'>
          {posts.map((post) => (
            <li key={post.slug} className='col-12 col-md-6'>
              <Link to={`/blog/${post.slug}`} className='blog-card'>
                {post.image && (
                  <div className='blog-card-image-wrap'>
                    <img
                      src={post.image}
                      alt=''
                      className='blog-card-image'
                      loading='lazy'
                    />
                  </div>
                )}
                <div className='blog-card-body'>
                  <h2 className='blog-card-title'>{post.title}</h2>
                  <time dateTime={post.date} className='blog-card-date'>{post.date}</time>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  )
}

export default BlogList
